<script>
import { mapGetters } from "vuex";
import { Popup } from "@v2/shared/ui/components";

export default {
  components: { Popup },
  async created() {
    if (
      this.$store.getters["auth/isAuthenticated"] &&
      this.layout === "default"
    ) {
      await this.$store.dispatch("auth/getUser");
    }
  },
  computed: {
    ...mapGetters({
      getErrorMessage: "common/getErrorMessage",
      layout: "common/layout"
    })
  },
  methods: {
    closePopup() {
      this.$store.commit("common/deleteErrorMessage");
    }
  }
};
</script>

<template>
  <div id="app">
    <component :is="layout + '-layout'">
      <router-view />
    </component>
    <Popup
      message
      class="global-popup"
      v-if="getErrorMessage"
      @close="closePopup"
    >
      <div class="global-popup__list">
        <p class="global-popup__item" v-html="getErrorMessage"></p>
      </div>
    </Popup>
  </div>
</template>

<style lang="scss">
@import "./styles/index.scss";
</style>
